import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { FacetListComponent, ViewModes } from '@spartacus/storefront';
import { ICON_TYPE_LIST } from '@app/spartacus/configurations/icon/icon.model';
import { map } from 'rxjs/operators';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '@app/custom/features/rrs-product-listing/configs/rrs-view.config';
import { PaginationModel, RoutingService } from '@spartacus/core';
import { RrsFacet } from '@app/custom/features/rrs-product-listing/model';
import { RrsProductFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-product-facet-service.service';
import { RrsProductListComponentService } from '@app/custom/features/rrs-product-listing/services/rrs-product-list/rrs-product-list-component.service';
import { RrsFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-facet-service/rrs-facet.service';
import { getFacetsUrlParams } from '@app/custom/features/rrs-product-listing/utils/rrs-facet.utils';
import { AutoUnsubscribe } from '@app/shared/decorators';
import { ModalService } from '@app/custom/features/modal';

@AutoUnsubscribe()
@Component({
  selector: 'rrs-facet-list',
  templateUrl: './rrs-facet-list.component.html',
  styleUrls: ['./rrs-facet-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RrsFacetListComponent extends FacetListComponent {
  @Input() isInDialog!: boolean;
  @Input() isActive!: boolean;
  iconTypeList = ICON_TYPE_LIST;
  pageSizeOptions = PAGE_SIZE_OPTIONS;
  pagination$: Observable<PaginationModel | undefined>;
  viewMode$ = this.productListComponentService.viewMode$;
  viewModes = ViewModes;
  isApplied = false;
  subscriptions = new Subscription();
  currentSearchQuery$: Observable<string> =
    this.productFacetService.result$.pipe(
      map((result) => result.currentQuery?.query?.value ?? '')
    );

  facetFilters: any;
  currentSearchQuery: any;

  constructor(
    protected facetService: RrsFacetService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2,
    protected productFacetService: RrsProductFacetService,
    protected productListComponentService: RrsProductListComponentService,
    protected routing: RoutingService,
    protected modalService: ModalService
  ) {
    super(facetService, elementRef, renderer);
    this.pagination$ = this.productListComponentService.model$.pipe(
      map((model) => model.pagination)
    );
    this.subscriptions.add(
      combineLatest([
        this.currentSearchQuery$,
        this.facetService.mobileDialogSelectedFacets$,
      ]).subscribe(([res, query]) => {
        this.currentSearchQuery = res;
        this.facetFilters = getFacetsUrlParams(query);
      })
    );
  }

  getFacetName(_: number, facet: RrsFacet): string {
    return facet.name!;
  }

  apply(): void {
    this.isApplied = true;
    this.routing.go(
      {
        cxRoute: 'search',
        params: { query: this.currentSearchQuery },
      },
      {
        queryParams: {
          facetFilters: this.facetFilters,
        },
        queryParamsHandling: 'merge',
      }
    );
    this.modalService.closeActiveModal();
  }

  cancel(): void {
    this.facetService.initialMobileFacets();
    this.modalService.closeActiveModal();
  }

  closeDialog(): void {
    this.facetService.initialMobileFacets();
    this.modalService.closeActiveModal();
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  setViewMode(mode: ViewModes): void {
    this.productListComponentService.setViewMode(
      mode === ViewModes.Grid ? ViewModes.List : ViewModes.Grid
    );
  }
}
